import { useEffect } from "react";

import BasicInfoSection from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ClientInfoV2/BasicInfoSection";
import Navigation from "../../../../../components/navigations/client/detail/client-info/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { useQueryParams } from "../../../../../hooks/useQueryParams";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case, _clientId } = useParentLoaderData(2);
  const { updateFilter } = useQueryParams();

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/client-info/personal");
  }, []);

  useEffect(() => {
    if (_clientId !== null) {
      const current = new URL(window.location.href);
      const currentClient = current.searchParams.get("client");
      if (String(currentClient) !== String(_clientId)) {
        updateFilter("client", String(_clientId), null, true);
      }
    }
  }, [_clientId]);

  return (
    <Navigation activeTab="personal" _case={_case}>
      <BasicInfoSection caseObj={_case} />
    </Navigation>
  );
};
